import { router } from '@honeycomb/routing';
import { QueryParamsEnum, validateSearchQueryParams, } from '@honeycomb/data';
import { getQueryString } from './getQueryString';
import { getNonInfantsCount } from './getNonInfantsCount';
import { csvContainsAny } from './string-utils';
export const isHotelOnlyTransferEnabledforChannel = (hotelTransferEnabledChannels) => {
    const channels = hotelTransferEnabledChannels.split(',');
    const params = new URLSearchParams(getQueryString(router.query()));
    const source = params.get('source');
    if (source) {
        return channels.includes(source);
    }
    return true;
};
export const getTotalDeltaPrice = (deltaPricePerPerson, rooms) => {
    const nonInfantCount = rooms.reduce((prev, cur) => {
        return prev + getNonInfantsCount(cur);
    }, 0);
    return deltaPricePerPerson * nonInfantCount;
};
export const isValidEstablishmentPageQuery = (tripId) => {
    var _a;
    const queryParams = router.query();
    if (!tripId && !queryParams)
        return false;
    const isSearchQueryValid = queryParams ? validateSearchQueryParams(queryParams) : false;
    const searchParams = new URLSearchParams(getQueryString(queryParams));
    const isTripStatePresent = Boolean((_a = (tripId !== null && tripId !== void 0 ? tripId : searchParams.get(QueryParamsEnum.TRIP_STATE_ID))) === null || _a === void 0 ? void 0 : _a.replace(/0/g, ''));
    return isSearchQueryValid || isTripStatePresent;
};
export const isDestinationEnabledInConfig = (searchState, config, isLandingPage, isCacheEnabled) => {
    var _a, _b, _c;
    if (isLandingPage)
        return false;
    const destinationIds = isCacheEnabled
        ? (_b = (_a = searchState === null || searchState === void 0 ? void 0 : searchState.destinations) === null || _a === void 0 ? void 0 : _a.flatMap((dest) => { var _a; return (_a = dest === null || dest === void 0 ? void 0 : dest.id) !== null && _a !== void 0 ? _a : []; })) !== null && _b !== void 0 ? _b : []
        : (_c = searchState === null || searchState === void 0 ? void 0 : searchState.destinationIds) !== null && _c !== void 0 ? _c : [];
    return csvContainsAny(config, destinationIds);
};
export const getNextCheapestRoom = (boardOptions, unavailableRoomIds) => {
    var _a, _b, _c, _d;
    if (!(boardOptions === null || boardOptions === void 0 ? void 0 : boardOptions.length))
        return null;
    const availableRooms = (_a = boardOptions === null || boardOptions === void 0 ? void 0 : boardOptions.flatMap((bo) => {
        var _a, _b, _c;
        // Currently, only dealing with the one room.
        const room = (_a = bo.requestedRooms) === null || _a === void 0 ? void 0 : _a[0];
        return (_c = (_b = room === null || room === void 0 ? void 0 : room.availableRooms) === null || _b === void 0 ? void 0 : _b.filter((ar) => !unavailableRoomIds.includes(ar.roomId))) !== null && _c !== void 0 ? _c : [];
    })) !== null && _a !== void 0 ? _a : [];
    if (availableRooms.length === 0) {
        return null;
    }
    const cheapestRoom = availableRooms.reduce((prev, curr) => {
        var _a, _b, _c, _d, _e, _f;
        const prevPrice = (_c = (_b = (_a = prev === null || prev === void 0 ? void 0 : prev.pricingSummary) === null || _a === void 0 ? void 0 : _a.teaserPrice) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : Infinity;
        const currPrice = (_f = (_e = (_d = curr === null || curr === void 0 ? void 0 : curr.pricingSummary) === null || _d === void 0 ? void 0 : _d.teaserPrice) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : Infinity;
        return currPrice < prevPrice ? curr : prev;
    });
    return {
        boardRoomId: cheapestRoom.roomId,
        boardType: (_b = cheapestRoom.pricingSummary) === null || _b === void 0 ? void 0 : _b.boardType,
        boardTypeDescription: (_c = cheapestRoom.pricingSummary) === null || _c === void 0 ? void 0 : _c.boardTypeDescription,
        pricingSummary: cheapestRoom.pricingSummary,
        roomDescription: (_d = cheapestRoom.masterRoom) === null || _d === void 0 ? void 0 : _d.title,
    };
};
